import React from "react";

const TaskOnRouteStatusIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#52EF9C" />
        <path
            d="M29.6442 22.5703V18.5727L26.3191 17.3976L24.0145 14.0631C23.6411 13.5227 23.0261 13.2002 22.3692 13.2002H20.4147H17V18.0002H12.5H8V21.5002V23.5202H12.6208M29.6442 22.5703H30.319V23.5202H29.6442V22.5703ZM17.5 23.5002H22M12.6208 23.5202C12.543 23.7026 12.5 23.9034 12.5 24.1143C12.5 24.9526 13.1792 25.6333 14.0166 25.6333C14.8542 25.6333 15.5335 24.9527 15.5335 24.1143C15.5335 23.2765 14.8547 22.5988 14.0166 22.5988C13.3897 22.5988 12.8519 22.9782 12.6208 23.5202ZM27.139 24.1143C27.139 24.9527 26.4598 25.6333 25.6221 25.6333C24.7847 25.6333 24.1055 24.9526 24.1055 24.1143C24.1055 23.2765 24.7843 22.5988 25.6221 22.5988C26.4602 22.5988 27.139 23.2765 27.139 24.1143ZM19.5 15.5002V18.0002H21.8028H24.1055L22.5 15.5002H21H19.5Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TaskOnRouteStatusIcon;
